<script setup lang="ts">
import { CheckIcon, Link } from 'lucide-vue-next'
import { getHostname } from '~~/src/api'
import type { Elemental } from '~~/src/types/elemental'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
const { elemental, route } = defineProps<{
  elemental: Elemental
  route: string
}>()

const { copied, copy } = useClipboard()
const host = getHostname()

const copyLink = () => {
  const link = `${host}/${route}/${elemental.id}`
  copy(link)
}

defineOptions({
  name: 'CopyElementalLinkOption',
})
</script>

<template>
  <DropdownMenuItem @select.prevent="copyLink">
    <CheckIcon v-if="copied" />
    <Link v-else />
    Copy Link
  </DropdownMenuItem>
</template>
